import { Box, Button } from "@mui/material";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ModalBox from "../ModalBox";
import { useState } from "react";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";

const PaidStatusAction = ({ row, actions }) => {
  const [OpenPaid, setOpenPaid] = useState(false);

  const [OpenVoid, setOpenVoid] = useState(false);
  const [OpenComp, setOpenComp] = useState(false);
  return (
    <>
      {row.statusId === 6 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "fit-content",
          }}
        >
          <Button
            onClick={() => {
              setOpenPaid(!OpenPaid);
            }}
            sx={{
              background: "black",
              "&:hover": {
                background: `black`,
              },
              color: "white",
              width: "170px",
              margin: "5px",
              textTransform: "capitalize",
            }}
          >
            <PaymentsOutlinedIcon
              fontSize="small"
              style={{ marginRight: "4px" }}
            />{" "}
            Change Status
          </Button>
          {(row.paidStatusId === 3 || row.paidStatusId === 5) && (
            <Button
              onClick={() => {
                setOpenVoid(!OpenVoid);
              }}
              sx={{
                color: "#FFC555",
                border: "1px solid #FFC555",
                width: "80px",
                height: "35px",
                textTransform: "capitalize",
                margin: "5px",

                "&:hover": {
                  background: `#FFC555`,
                  color: "white",
                },
              }}
            >
              <ChangeCircleOutlinedIcon
                fontSize="small"
                style={{ marginRight: "4px" }}
              />
              Void
            </Button>
          )}
          {row.paidStatusId === 3 && (
            <Button
              onClick={() => {
                setOpenComp(!OpenComp);
              }}
              sx={{
                color: "#FFC555",
                border: "1px solid #FFC555",
                width: "80px",
                height: "35px",
                textTransform: "capitalize",
                margin: "5px",

                "&:hover": {
                  background: `#FFC555`,
                  color: "white",
                },
              }}
            >
              <ChangeCircleOutlinedIcon
                fontSize="small"
                style={{ marginRight: "4px" }}
              />
              Comp
            </Button>
          )}

          <ModalBox
            open={OpenPaid}
            handleClose={() => {
              setOpenPaid(!OpenPaid);
            }}
            row={row}
            handleOperation={actions.PaidStatus}
            operation="PaidStatus"
            height={"fit-content"}
          />
          <ModalBox
            open={OpenVoid}
            handleClose={() => {
              setOpenVoid(!OpenVoid);
            }}
            row={row}
            operation="Void"
            height={"fit-content"}
          />
          <ModalBox
            open={OpenComp}
            handleClose={() => {
              setOpenComp(!OpenComp);
            }}
            row={row}
            operation="Comp"
            height={"fit-content"}
          />
        </Box>
      )}
    </>
  );
};

export default PaidStatusAction;
